import { styled } from '@mui/system';
import { Grid, Box, Button } from '@mui/material';

export const StyledGrid = styled(Grid, {
  shouldForwardProp: prop => prop !== 'isLoading'
})(({ isLoading }) => ({
  ...(isLoading && {
    '& > div': {
      filter: 'blur(5px)',
      animation: 'blink 1s alternate infinite linear'
    },
    '@keyframes blink': {
      from: {
        opacity: 0.5
      },
      to: {
        opacity: 1
      }
    }
  })
}));

export const CreateButton = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText(theme.palette.secondary.main),
  padding: '3px 16px'
}));

export const MobileSection = styled(Box, {
  shouldForwardProp: prop => prop !== 'isEmptyContacts'
})(({ isEmptyContacts }) => ({
  ...(isEmptyContacts && {
    padding: '10px'
  })
}));
